import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { TranslocoModule } from '@jsverse/transloco';

import { CapitalizePipe } from '@hmax-order/frontend/utils';
import { ValidateFieldsService } from '../validate-fields.service';

@Component({
  selector: 'hmax-input-text',
  standalone: true,
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CapitalizePipe, CommonModule, MatFormFieldModule, MatInputModule, MatIconModule, ReactiveFormsModule, TranslocoModule],
})
export class InputTextComponent implements OnInit {
  public validateField = inject(ValidateFieldsService);
  @ViewChild('inputRef', { static: false, read: ElementRef }) input!: ElementRef;

  inputId!: string;

  @Input() autocomplete = '';
  @Input() controlName!: string;
  @Input() formGroup!: FormGroup;
  @Input() label!: string;
  @Input() icon!: string;
  @Input() iconSize = 5;
  @Input() inputIdentifier = '';
  @Input() placeholder!: string;
  @Input() appearance: 'outline' | 'fill' = 'outline';
  @Input() onBlur = false;
  @Input() errorRequired = 'required-field';
  @Input() maxLength = 255;
  @Input() readonly = false;

  @Output() blurEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  get formControl(): AbstractControl {
    return this.formGroup.controls[this.controlName];
  }

  ngOnInit(): void {
    this.inputId = this.inputIdentifier;
    // Carregar controlName com o label se não houver controlName definido
    this.controlName = this.controlName ?? this.label;
  }

  doBlur(): void {
    if (this.onBlur) {
      this.blurEmitter.emit(true);
    }
  }
}
